import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-azure-wafr-pillars",
  templateUrl: "./azure-wafr-pillars.component.html",
  styleUrls: ["../../azure-wafr-workloads.component.css"],
})
export class AzureWafrPillarsComponent {
  @Input() selectedLens: any = null;
  @Input() pillars: any[] = [];
  @Input() pillarsLoading = false;
  @Input() pillarsError: string = null;

  @Output() back = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();
  @Output() openPillar = new EventEmitter<any>();

  onBack() {
    this.back.emit();
  }

  onRefresh() {
    this.refresh.emit();
  }

  onOpenPillar(pillar: any) {
    this.openPillar.emit(pillar);
  }
}
